/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

/**
 * Form for updating a remote MCP server
 */
export type UpdateServerForm = {
  /**
   * The ID of the remote MCP server to update
   */
  id: string;
  /**
   * Optional human-readable name. Pass an empty string to clear the existing name.
   */
  name?: string | undefined;
  /**
   * The transport type for the remote MCP server
   */
  transportType?: string | undefined;
  /**
   * The URL of the remote MCP server
   */
  url?: string | undefined;
};

/** @internal */
export type UpdateServerForm$Outbound = {
  id: string;
  name?: string | undefined;
  transport_type?: string | undefined;
  url?: string | undefined;
};

/** @internal */
export const UpdateServerForm$outboundSchema: z.ZodMiniType<
  UpdateServerForm$Outbound,
  UpdateServerForm
> = z.pipe(
  z.object({
    id: z.string(),
    name: z.optional(z.string()),
    transportType: z.optional(z.string()),
    url: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      transportType: "transport_type",
    });
  }),
);

export function updateServerFormToJSON(
  updateServerForm: UpdateServerForm,
): string {
  return JSON.stringify(
    UpdateServerForm$outboundSchema.parse(updateServerForm),
  );
}
